<template>
    <div>
        <a-card size="small" title="业务分类">
            <a-button slot="extra" type="primary" @click="handleNew">新增</a-button>
        </a-card>
        <channelSelecter :isDisabled="false" @onChannelCodeChange="handleChannelChange"></channelSelecter>
        <a-card size="small">
            <searchE @handleSearch="handleSubmit"></searchE>
            <tableE ref="serviceTableID"></tableE>
        </a-card>
    </div>
</template>
<script>
import tableE from './table'
import searchE from './search'
import channelSelecter from '../../components/channelSelecter'

export default {
    data() {
        return {
            channelcode:'',
            searchP:{
                keyword:'',
                channelcode:'',
            }
        };
    },
    methods: {
        handleChannelChange(item){
            this.channelcode = item.value;
            this.searchP.channelcode = item.value;
            this.$refs.serviceTableID.handleSearch(this.searchP);

        },
        handleSubmit(searchP){
            this.searchP = searchP;
            searchP.channelcode = this.channelcode;
            this.$refs.serviceTableID.handleSearch(this.searchP);
        },

        handleNew(){
            this.$router.push({
                path: "add_servicetype",
                query: {id:''}
            });
        }
    },
    components:{
        tableE,
        searchE,
        channelSelecter
    },
    mounted(){

    }
};
</script>
<style scoped>

</style>
